import classNames from "classnames"

type Style = 
  | 'h4' 
  | 'h6' 
  | 'p' 
  | 'caption' 
  | 'label'
  | 'button-quaternary-dark'
  | 'heading'

type Props = {
  style?: Style;
  children?: number | string | (string | number)[]
  className?: string
}

const MAP_STYLE_TO_CLASSNAMES: Record<Style, string>  = {
  'h4': 'h4',
  'h6': 'h6',
  'p': 'font-bstSpyre font-light tracking-[0.56px]',
  'label': 'font-calibre font-light tracking-[1.12px] uppercase',
  'caption': 'font-calibre font-light text-[12px]',
  'button-quaternary-dark': 'Button Button--quaternary-dark',
  'heading': 'Heading'
}

export const Text = ({ style, children, className }: Props) => {
  return (
    <span className={classNames(style ? MAP_STYLE_TO_CLASSNAMES[style] : "", className)}>
      {children}
    </span>
  )
}